import React, { type FunctionComponent } from 'react'
import { useParams } from 'react-router'
import { Breadcrumb, Breadcrumbs } from '@retailer-platform/shared-components'
import { type PartnerScopedRouteParams } from 'legacy/common/types'
import { useScopedPathname } from 'utils/routing/url.hooks'
import { useDomainMessage } from 'domains/account-management/utils/domain/intl'

export const AccountManagementBreadcrumbs: FunctionComponent = ({ children }) => {
  const { partner_id: partnerId } = useParams<PartnerScopedRouteParams>()
  const accountManagementRoot = partnerId
    ? 'retailer-account-management-list'
    : 'app-admin-account-management-list'
  const rootText = useDomainMessage('accountManagementDomain.breadcrumbs.root')
  const path = useScopedPathname(accountManagementRoot)

  return (
    <Breadcrumbs>
      <Breadcrumb path={children ? path : null}>{rootText}</Breadcrumb>
      {children}
    </Breadcrumbs>
  )
}
